import { render, staticRenderFns } from "./ExerciseConfigForm.vue?vue&type=template&id=28aba300"
import script from "./ExerciseConfigForm.vue?vue&type=script&lang=js"
export * from "./ExerciseConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports